<template>
  <div class="card">
    <div class="card-header">
      {{ problem.id ? $t("Edit Problem") : $t("Create Problem") }}
    </div>
    <div class="card-body">
      <b-form @submit.prevent="handleSubmit">
        <!-- Company Selection -->
        <b-row>
          <b-col md="8">
            <b-form-group
              label="Company"
              :state="getFieldState('company_id')"
              invalid-feedback="Please select a company"
            >
              <b-form-select
                v-model="form.company_id"
                :options="formattedCompanies"
                :state="getFieldState('company_id')"
                disabled
              ></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Name Fields for Languages -->
        <b-row>
          <b-col md="4" sm="6" class="col-xs-12" v-for="language in languages" :key="language.code">
            <b-form-group
              :label="$t('Name') + ' (' + language.name + ')'"
              :state="getFieldState(`name.${language.code}`)"
            >
              <b-form-input
                v-model="form.name[language.code]"
                :state="getFieldState(`name.${language.code}`)"
              ></b-form-input>
              <div v-if="errors[`name.${language.code}`]" class="invalid-feedback">
                {{ errors[`name.${language.code}`] }}
              </div>
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Submit Button -->
        <b-button :disabled="loading" variant="primary" type="submit">
          <span
            v-if="loading"
            class="spinner-border spinner-border-sm"
            role="status"
          ></span>
          {{ problem.id ? $t("Save Problem") : $t("Create Problem") }}
        </b-button>
      </b-form>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "ProblemForm",
  props: {
    problem: {
      type: Object,
      required: true
    },
    category: {
      type: Object,
      required: true
    },
    companies: {
      type: Array,
      required: true
    },
    languages: {
      type: Array,
      required: true
    },
    formAction: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      form: {
        company_id:
          this.problem.company_id !== undefined &&
          this.problem.company_id !== null
            ? this.problem.company_id
            : this.category.company_id || null,
        name: this.languages.reduce((acc, language) => {
          acc[language.code] = this.problem.name?.[language.code] || "";
          return acc;
        }, {})
      },
      errors: {},
      loading: false
    };
  },
  computed: {
    formattedCompanies() {
      return [
        { value: null, text: this.$t("System") },
        ...this.companies.map(company => ({
          value: company.id,
          text: company.name
        }))
      ];
    }
  },
  mounted() {
    if (this.form.company_id === null) {
      this.form.company_id = null; // Cela garantit que "System" est sélectionné
    }
  },
  methods: {
    getFieldState(field) {
      return this.errors[field] === undefined ? null : false;
    },
    async handleSubmit() {
      this.loading = true;
      this.errors = {};

      try {
        const method = this.problem.id ? "put" : "post"; // Détermine le type de méthode
        const url = this.formAction; // Utilise `formAction` passé depuis Blade
        const payload = { ...this.form }; // Prépare les données du formulaire

        await axios[method](url, payload); // Envoie la requête avec la méthode appropriée

        this.$bvToast.toast(
          this.problem.id
            ? this.$t("Problem updated successfully!")
            : this.$t("Problem created successfully!"),
          {
            title: "Success",
            variant: "success",
            solid: true
          }
        );

        setTimeout(() => {
          window.location.href = `/settings/problem-categories/${
            this.category.id
          }`;
        }, 1000);
      } catch (error) {
        if (error.response && error.response.data.errors) {
          this.errors = error.response.data.errors;
        } else {
          this.$bvToast.toast(this.$t("An error occurred. Please try again."), {
            title: "Error",
            variant: "danger",
            solid: true
          });
        }
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
